import React, { useState, useEffect } from "react";
import ToastService from '../../../services/ToastService';
import MasterService from '../../../services/MasterService';
import DocumentService from '../../../services/DocumentService';
import { showLoading } from 'react-global-loading';

export const userData = localStorage.getItem('persist:root')
  ? JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData)
  : '';

const AddDocuments = (props) => {
  // State variables
  const [docTitle, setDocTitle] = useState('');
  const [docDesc, setDocDesc] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [docApi, setDocApi] = useState('');
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  useEffect(() => {
    showLoading(true);
    getCategories();
    getAllCountries();
  }, []);

  const getAllCountries = () => {
    MasterService.getAyushCountries()
      .then((result) => {
        if (!result) return;
        setCountries(result);
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) return;
        setCategories(result);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const deleteDoc = () => {
    setDocApi('');
  };

  const handleCategories = (status, catId) => {
    if (status) {
      setSelectedCategory([...selectedCategory, catId]);
    } else {
      setSelectedCategory(selectedCategory.filter((item) => item !== catId));
    }
  };

  const onDocSelection = (event) => {
    setDocApi(event.target.files[0]);
  };

  const onDocCreation = () => {
    showLoading(true);
    if ((selectedCountry || userData.blog_id?.userblog_id) && docTitle && docApi && selectedCategory.length > 0) {
      const data = new FormData();
      data.append('post_title', docTitle);
      data.append('post_content', docDesc);
      data.append('document_upload', docApi);
      data.append('category', selectedCategory);
      data.append("lang", localStorage.getItem('localLang'));
      userData.roles === "administrator"
        ? data.append('blog_id', selectedCountry)
        : data.append('blog_id', userData.blog_id?.userblog_id);

      if (props.location?.state?.editData) {
        DocumentService.updateDocument(data).then((result) => {
          result.data === 200 ? (
            ToastService.success(result.data.message),
            props.dismissModal()) :
            (ToastService.error(result.data.message));
        });
      } else {
        DocumentService.createDocument(data).then((result) => {
          result.data === 200 ? (
            showLoading(false),
            ToastService.success(result.data.message),
            props.dismissModal()) :
            (showLoading(false), ToastService.error(result.data.message),
              window.history.back());
        });
      }
    } else {
      ToastService.error("Please fill required details");
    }
  };

  return (
    <div className="container-fluid productscontainer" id="main">
      <div className="row mt-3">
        <div className="col-12">
          <div className="row mt-4 contrast-ration-sol">
            <div className="col-md-7">
              <div className="head-title">
                <h4>Add Document</h4>
              </div>
            </div>
            <div className="col-md-5 text-end alirr btr">
              <button onClick={onDocCreation} type="button" className="card-link rounded rounded-2 btntxdsh darkbtn">Save Document</button>
            </div>
          </div>
          <div className="row box-main mt-4 mb-3 bg-white">
            <div className="col-md-6 mt-2">
              <div className="form-group mb-4 position-relative">
                <label htmlFor="documenttitle" id="documenttitle" className="form-label over-label">Document Title *</label>
                <input aria-labelledby="documenttitle" type="text" className="form-control" name="documenttitle" value={docTitle}
                  onChange={(e) => setDocTitle(e.target.value)} />
              </div>
              {userData.roles === "administrator" && (
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="documenttitle" className="bldlbl" id="selectcountry">Select country *</label>
                  <select name='orderby' className='form-control' aria-labelledby='selectcountry' value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}>
                    <option defaultValue='selected' value=''>Countries*</option>
                    {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
                  </select>
                </div>
              )}
              <div className="form-group mb-4 position-relative">
                <label htmlFor="documentdescription" id="documentdescription" className="form-label over-label">Document Description </label>
                <textarea aria-labelledby="documentdescription" className="form-control" rows="3" value={docDesc}
                  onChange={(e) => setDocDesc(e.target.value)}></textarea>
              </div>
              <div className="form-group mb-4 position-relative">
                <label htmlFor="eventname" className="form-label"><b>Select Domain*:</b></label>
                <div className="btn-group d-block event-check" role="group" aria-label="Basic checkbox toggle button group">
                  {categories.map((item, index) => (
                    <span key={index}>
                      <input type="checkbox" className="btn-check" id={index} autoComplete="off" onClick={(e) => handleCategories(e.target.checked, item.name)} />
                      <label className="btn btn-outline-dark btn-sm" htmlFor={index}>{item.name}</label>
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-6 tab-content d-flex mt-2 pdtb15" id="pills-tabContent">
              <div className="d-flex align-items-center position-relative">
                {docApi ? (
                  <>
                    <img src={require('../../../public/pdf_view-all.png')} className="img-fluid" alt="pdf file" />
                    <span>{docApi.name}</span>
                  </>
                ) : (
                  <>
                    <i className="fa fa-plus fs-3 text-secondary adddocs" aria-hidden="true"></i>
                    <p className="tab-para">Drop your Files Here</p>
                    <input aria-labelledby="uploaddocument" id="uploaddocument" type="file" name="file" accept="application/pdf" onChange={onDocSelection} />
                    <small className="text-muted pt-3">Upload Document in pdf format</small>
                  </>
                )}
                {docApi && (
                  <div className="d-block del-btn">
                    <button onClick={deleteDoc}>
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDocuments;
